import { render, staticRenderFns } from "./TabelaListarTerritorioMonitoramento.vue?vue&type=template&id=25f635ca&lang=pug"
import script from "./TabelaListarTerritorioMonitoramento.vue?vue&type=script&lang=js"
export * from "./TabelaListarTerritorioMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./TabelaListarTerritorioMonitoramento.vue?vue&type=style&index=0&id=25f635ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports